import { type User } from "@vidario/domain";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";

/** Directory of app-level users. Admin-only in production (RLS filters the
 * table); the mock endpoint returns everyone seeded in the store. Used
 * by the Dashboard's recruiter filter and Settings' "Neuen Nutzer" form. */
export function useUsers(): UseQueryResult<User[]> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: ["users"],
    queryFn: () => client.getUsers(),
    staleTime: 5 * 60 * 1000,
  });
}
